import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    '& .geosuggest': {
      fontSize: '18px',
      position: 'relative',
      textAlign: 'unset',
    },
    '& .geosuggest__input': {
      background: '#fff4f1',
      boxSizing: 'border-box',
      fontSize: 16,
      width: '100%',
      border: '1px solid #FF8C69',
      // boxShadow: '0 0 1px #3d464d',
      padding: '15px',
      outline: 'none',
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
      },
    },
    '& .geosuggest__suggests': {
      position: 'absolute',
      top: '100%',
      left: '0',
      right: '0',
      maxHeight: 320,
      padding: '0',
      marginTop: '-1px',
      background: '#fff',
      border: '1px solid #FF8C69',
      borderTopWidth: '0',
      overflowX: 'hidden',
      overflowY: 'auto',
      listStyle: 'none',
      zIndex: '5',
      '-webkit-transition': 'maxHeight 0.2s, border 0.2s',
      transition: 'maxHeight 0.2s, border 0.2s',
    },
    '& .geosuggest__suggests--hidden': {
      maxHeight: '0',
      overflow: 'hidden',
      borderWidth: '0',
    },
    '& .geosuggest__item': {
      fontSize: '1rem',
      padding: '.5em .65em',
      cursor: 'pointer',
      '&:hover': {
        background: '#f5f5f5',
      },
      '&:focus': {
        background: '#f5f5f5',
      },
    },
    '& .geosuggest__item--active': {
      background: '#FF8C69',
      color: '#fff',
      '&:hover': {
        background: '#ccc',
      },
      '&:focus': {
        background: '#ccc',
      },
    },
    '& .geosuggest__item__matched-text': {
      fontWeight: 'bold',
    },
  },
}));
